<ui-modal modalTitle="Note" [scrollable]="true">
	<div *ngIf="list">
		<div *ngFor="let activity of list ; let i = index" class="border p-2 mb-2 rounded mr-2">
			<div class="d-flex mb-2 align-items-start">
				<div class="flex-weight-1 mr-2">
					<div class="d-flex mr-2">
						<ui-user-image [email]="activity.user_email"></ui-user-image>
						<div class="flex-weight-1 mx-2">
							<div class="text-bold text-large">{{activity.user_name}}</div>
							<div class="text-secondary text-small mb-1">{{activity.created_datetime | mySQLDateToISO | localizedDate:'shortDate'}} {{activity.created_datetime | mySQLDateToISO | localizedDate:'shortTime'}}</div>
						</div>
					</div>

					<div *ngIf="editing !== i" class="text-large ml-2 mb-1 text-pre"><span [innerHTML]="activity.note | linky"></span></div>
					<div *ngIf="editing === i">
						<form (submit)="saveNote()">
							<div class="input-group">
								<textarea rows="5" class="form-control" [(ngModel)]="editNote" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off"></textarea>
								<span class="input-group-append">
									<button type="submit" class="btn btn-success px-2"><i class="wq wq-check"></i></button>
									<button type="button" class="btn btn-secondary px-2" (click)="editing = null"><i class="wq wq-close"></i></button>
								</span>
							</div>
						</form>
					</div>
				</div>
				<div *ngIf="activity.type === 'resolve_follow_up'" class="bg-success-25 badge text-success mt-1 mr-3">Follow Up Resolved</div>
				<div *ngIf="activity.type === 'follow_up'" class="bg-warning-25 badge text-warning mt-1 mr-3">Follow Up</div>
				<div class="d-flex" *ngIf="activity.editable">
					<button class="btn btn-sm btn-outline-medium border-0 p-2 mr-1" (click)="editMode(i)">
						<i class="wq wq-edit selectable"></i>
					</button>
					<button class="btn btn-sm btn-outline-medium border-0 p-2" (click)="deleteNote(activity)">
						<i class="wq wq-delete selectable"></i>
					</button>
				</div>
			</div>
		</div>
		<p *ngIf="!list.length">No notes found.</p>
	</div>
	<button type="button" class="btn btn-secondary" (click)="modal.close()" ui-modal-footer>Close</button>
</ui-modal>
